var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('apexchart',{key:_vm.chartKey,ref:"realTimeChart",attrs:{"type":"line","width":"800","options":_vm.chartOptions,"series":_setup.chartData.financeChartSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }